import { lazy } from 'react';

export const MobileSettingsPageLazy = lazy(() => import('./MobileSettingsPage'));
